import React from 'react';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import Typography from '@material-ui/core/Typography';
import ButtonComponent from '../atoms/button';

export interface TimeLineEvent {
  time?: string;
  content?: React.ReactNode;
  icon?: React.ReactNode;
  img?: string;
  dotColor?: string;
}

interface TimelineProps {
  timelineData: TimeLineEvent[];
}
const CustomizedTimeline: React.FC<TimelineProps> = ({ timelineData }) => {
  return (
    <Timeline align="alternate">
      {timelineData.map((item, index) => (
        <TimelineItem key={index}>
          <TimelineOppositeContent>{item.time}</TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot
              variant="outlined"
              style={{
                borderColor: item.dotColor,
                backgroundColor: item.dotColor,
              }}
            />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            {item.img ? (
              <Typography variant="body1" component="span">
                Canhoto aprovado
                <ButtonComponent href={item.img} style={{ height: 25 }}>
                  Visualizar canhoto
                </ButtonComponent>
              </Typography>
            ) : (
              <Typography variant="subtitle1" component="p">
                {item.content}
              </Typography>
            )}
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  );
};
export default CustomizedTimeline;
